<div class="mt-4">
  <div class="welcome-screen container-sm mt-5 pt-5">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="card shadow-lg p-5">
          <h4 class="title">
            <i class="far fa-check-circle"></i> {{ "TITLE.TERMS-AND-CONDITIONS" | translate }}</h4>
          <div class="error-box text-center" *ngIf="errorMessage !==''">
            <i class="fas fa-exclamation-circle fa-2x text-danger"></i>
            <p class="text-danger fz-19">{{errorMessage}}</p>
          </div>
          <div class="margin-fixed text-center">
            <re-captcha (resolved)="resolved($event)" (error)="onError($event)" errorMode="handled" class="text-center"></re-captcha>
          </div>
          <div class="tacbox">
            <input id="checkbox" type="checkbox" (change)="checked($event)"/>
            <label> {{"LABEL.I-AGREE-TO-THESE" | translate}} <a
              href="javascript:"
              (click)="openModalPdfViewer4termAndConditions()"> {{"LABEL.TERMS-AND-CONDITIONS"| translate}}</a>.</label>
          </div>
          <div class="tacbox">
            <input id="checkbox1" type="checkbox" (change)="checked2($event)"/>
            <label> {{"LABEL.I-AGREE-TO-THESE" | translate}} <a
              href="javascript:"
              (click)="openModalPdfViewer4CertificateRequest()"> {{"LABEL.REQUEST-CERTIFICATE"| translate}}</a>.</label>
          </div>
          <div class="card-footer">
            <div class="buttons">
              <button class="btn btn-danger" (click)="goBack()"><i
                class="fa fa-reply"></i> {{"BUTTON.BACK" | translate}}</button>
              &nbsp;
              <button class="submit btn btn-success" (click)="accept()"><i
                class="fa fa-check-circle"></i> {{"BUTTON.ACCEPT" | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
